import React from 'react';
import { 
  BeakerIcon, 
  WrenchScrewdriverIcon, 
  AcademicCapIcon, 
  GlobeAltIcon, 
  ChartBarIcon, 
  SunIcon 
} from '@heroicons/react/24/outline';

const Services = () => {
  const services = [
    {
      title: "Irrigation Systems",
      description: "Feasibility studies, design, construction supervision of dams and schemes.",
      icon: <GlobeAltIcon className="w-8 h-8" />, 
      color: "bg-[#22c55e]" // Matches Hero Green
    },
    {
      title: "Water & WASH",
      description: "Infrastructure assessments and hygiene training for rural communities.",
      icon: <BeakerIcon className="w-8 h-8" />, 
      color: "bg-[#1e3a8a]" // Matches Hero Dark Blue
    },
    {
      title: "Rural Development",
      description: "Community empowerment and innovative social development strategies.",
      icon: <WrenchScrewdriverIcon className="w-8 h-8" />, 
      color: "bg-[#22c55e]"
    },
    {
      title: "Agriculture & Agronomy",
      description: "Expertise in crop production and optimized irrigation agronomy.",
      icon: <SunIcon className="w-8 h-8" />, 
      color: "bg-[#1e3a8a]"
    },
    {
      title: "Research & Analysis",
      description: "Baseline studies, socio-economic evaluations, and action research.",
      icon: <ChartBarIcon className="w-8 h-8" />, 
      color: "bg-[#22c55e]"
    },
    {
      title: "Capacity Building",
      description: "Adult-based experiential learning and technical vocational training.",
      icon: <AcademicCapIcon className="w-8 h-8" />, 
      color: "bg-[#1e3a8a]"
    }
  ];

  return (
    <div id="services" className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-extrabold text-[#1e3a8a] mb-4 uppercase tracking-tight">
            Our <span className="text-[#22c55e]">Services</span>
          </h2>
          <div className="w-24 h-1 bg-[#22c55e] mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-xl mx-auto italic font-medium">
            "Diagnose | Co-Innovate | Transform"
          </p>
        </div>

        {/* --- Services Grid: 3 columns on large screens, 2 on tablets, 1 on mobile --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-20 gap-x-12">
          {services.map((service, index) => (
            <div key={index} className="flex flex-col items-center group relative">
              
              {/* --- Icon Circle --- */}
              <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center -mb-8 z-10 border-4 border-gray-50 shadow-xl group-hover:border-[#22c55e] transition-all duration-300">
                <div className="text-[#1e3a8a] group-hover:text-[#22c55e] transition-colors">
                  {service.icon}
                </div>
              </div>

              {/* --- Card Body --- */}
              <div className={`w-full h-full pt-14 pb-12 px-8 rounded-t-3xl rounded-b-[110px] shadow-lg transition-all duration-500 group-hover:-translate-y-2 ${service.color}`}>
                <h3 className="text-xl font-bold text-white mb-4 text-center">
                  {service.title}
                </h3>
                <p className="text-sm text-center text-white/95 leading-relaxed font-medium">
                  {service.description}
                </p>
                {/* Removed the dots to prevent "incomplete" look */}
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;